import ApiGateway from '../../aws/api-gateway/ApiGateway';
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'NetworkApi';
const requestCoverageReport = async (params) => {
    const response = { err: null, data: null };
    debug && console.log('requestCoverageReport request', params);
    try {
        /** this will be an xml SendMessageReponse forwarded by the HttpGateway */
        response.data = await ApiGateway.post('/networkCoverage', { ...params }, apiRef);
        debug && console.log('requestCoverageReport response', response);
    }
    catch (e) {
        response.err = e;
    }
    return response;
};
export const CoverageDAO = {
    requestCoverageReport,
};
